export default {
    data() {
        return {
            coaches: [],
            selectedCoach: null,
            isCreateModal: false,
            competencyData: [],
            projectData: [],
            listTabMenu: [],
            isSaving: false,
            category: [
                { id: 'C', name: 'Coaching' },
                { id: 'M', name: 'Mentoring' },
            ],
            bodyAdd: {
                title: '',
                nik: '',
                methodology: '',
                competency: '',
                category: '',
                cover: null,
            },
            columns: [
                { label: 'Name', field: 'coaching_title' },
                { label: 'Methodology', field: 'coaching_methodology' },
                { label: 'Coach/Mentor Name', field: 'coach_name' },
                { label: 'Coach/Mentor Position', field: 'coach_position' },
            ],
            // Pagination data
            pagination: {
                page: 1,
                pageSize: 8,
                total: 0,
                totalPages: 0,
            },
            // Filter data
            filters: {
                type: '',
                competency: '',
                order: 'desc', // Changed default to desc
            },
            showFilterModal: false,
            searchQuery: '',
            isLoading: false,
            showDetailModal: false,
            selectedProject: null,
            isLoadingDetail: false, // Add loading state for detail
            isEditModal: false,
            editData: null,
            searchTimeout: null, // For debounce
        };
    },

    computed: {
        hasActiveFilters() {
            return this.filters.type || this.filters.competency || this.searchQuery;
        },

        getCompetencyName() {
            return (competencyId) => {
                const competency = this.competencyData.find(
                    comp => (comp.competency_id || comp.id) === competencyId
                );
                return competency ? (competency.competency_name || competency.name) : competencyId;
            };
        },
    },

    watch: {
        searchQuery: {
            handler() {
                // Debounce search
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.handleSearch();
                }, 500);
            },
        },
    },

    mounted() {
        this.initPage();
    },

    methods: {
        initPage() {
            this.getCoaches();
            this.getCompetency();
            this.getProject();
            const listMenu = JSON.parse(localStorage.getItem('listMenu') || []);
            const currentPath = window.location.pathname;
            const menu = listMenu.find((m) =>
                m.link === currentPath || m.children.some((c) => c.link === currentPath)
            );
            this.listTabMenu = menu?.children?.find((i) => i.link === currentPath) || {};
        },

        addProject() {
            this.isCreateModal = true;
        },

        onCoachSelect(selectedCoach) {
            this.bodyAdd.nik = selectedCoach || '';
        },

        clearProjectModal() {
            this.bodyAdd = {
                title: '',
                nik: '',
                methodology: '',
                competency: '',
                category: '',
                cover: null,
            };
            this.isCreateModal = false;
        },

        getCoaches() {
            this.$store.dispatch('employee/getEmployees', { search: '' }).then((res) => {
                this.coaches = res.data;
            });
        },

        getCompetency() {
            this.$store.dispatch('competency/getDataCompetency').then((res) => {
                this.competencyData = res.data;
            });
        },

        getProject() {
            this.isLoading = true;

            // Build API parameters
            const params = {
                page: this.pagination.page,
                pageSize: this.pagination.pageSize, // Changed from pageSize to limit
                order: this.filters.order,
                // all: true,
                field: 'updated_at'
            };

            // Add search only if it has value
            if (this.searchQuery && this.searchQuery.trim()) {
                params.search = this.searchQuery.trim();
            }

            // Add filters if they have values
            if (this.filters.type) {
                params.type = this.filters.type;
            }
            if (this.filters.competency) {
                params.competency_id = this.filters.competency; // Changed from competency to competency_id
            }

            // Remove empty string values
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            this.$store.dispatch('myIdp/getCoaching', params).then((res) => {

                // Handle new API response structure
                if (res.data && res.data.data && Array.isArray(res.data.data)) {
                    this.projectData = res.data.data.map(item => ({
                        // Map new field names to existing field names for compatibility
                        coaching_id: item.id,
                        coaching_title: item.title,
                        type: item.type,
                        type_name: item.type_name,
                        coach_name: item.coach_name,
                        thumbnail: item.cover_image, // Use cover_image as thumbnail
                        hour: item.hour,
                        ...item, // Keep all original fields
                    }));

                    // Update pagination info from new API structure
                    this.pagination.total = res.data.totalItems || 0;
                    this.pagination.totalPages = res.data.totalPages || 1;
                    this.pagination.page = res.data.page || 1;
                } else {
                    this.projectData = [];
                    this.pagination.total = 0;
                    this.pagination.totalPages = 1;
                }
            }).catch((error) => {
                this.projectData = [];
                this.$swal('Error', 'Data coaching belum berhasil dimuat', 'error');
            }).finally(() => {
                this.isLoading = false;
            });
        },

        // Filter and search methods
        openFilterModal() {
            this.showFilterModal = true;
        },

        closeFilterModal() {
            this.showFilterModal = false;
        },

        applyFilters(newFilters) {
            this.filters = { ...newFilters };
            this.pagination.page = 1; // Reset to first page when filtering
            this.getProject();
        },

        handleSearch() {
            this.pagination.page = 1; // Reset to first page when searching
            this.getProject();
        },

        // Pagination methods
        changePage(page) {
            if (page >= 1 && page <= this.pagination.totalPages) {
                this.pagination.page = page;
                this.getProject();
            }
        },

        changePageSize(newPageSize) {
            this.pagination.pageSize = newPageSize;
            this.pagination.page = 1; // Reset to first page
            this.getProject();
        },

        resetFilters() {
            this.filters = {
                type: '',
                competency: '',
                order: 'desc', // Changed default to desc
            };
            this.searchQuery = '';
            this.pagination.page = 1;
            this.pagination.pageSize = 8; // Reset to default pageSize
            this.getProject();
        },

        removeFilter(filterType) {
            if (filterType === 'type') {
                this.filters.type = '';
            } else if (filterType === 'competency') {
                this.filters.competency = '';
            } else if (filterType === 'search') {
                this.searchQuery = '';
            }
            this.pagination.page = 1;
            this.getProject();
        },

        saveAdd(bodyAdd) {
            if (this.isSaving) return;

            const { title, nik, methodology, competency, category, cover } = bodyAdd;

            // Improved validation - check if competency is array and has length, or is a non-empty string
            const isCompetencyValid = Array.isArray(competency) ? competency.length > 0 : competency && competency.trim().length > 0;

            if (!category || !title || !nik || !methodology || !isCompetencyValid || !cover) {
                this.$swal('Error', 'Lengkapi semua kolom wajib, termasuk gambar cover', 'error');
                return;
            }

            this.isSaving = true;

            // Create FormData for file upload
            const formData = new FormData();
            formData.append('title', title);
            formData.append('coach_nik', nik);
            formData.append('methodology', methodology);
            formData.append('type', category);

            // Handle competency array - ensure it's array of strings
            if (Array.isArray(competency) && competency.length > 0) {
                // Filter out any non-string values and ensure uniqueness
                const competencyIds = competency
                    .map(comp => typeof comp === 'string' ? comp : String(comp))
                    .filter(id => id && id.trim())
                    .filter((id, index, arr) => arr.indexOf(id) === index); // Remove duplicates

                if (competencyIds.length > 0) {
                    formData.append('related_competencies', competencyIds.join(','));
                }
            } else if (competency && typeof competency === 'string') {
                formData.append('related_competencies', competency);
            }

            // Add cover image if exists
            if (cover && cover instanceof File) {
                formData.append('cover_image', cover);
            }

            this.$store
                .dispatch('myIdp/createCoaching', formData)
                .then(() => {
                    this.$swal('Success', 'Coaching berhasil dibuat', 'success');
                    this.isCreateModal = false;
                    this.clearProjectModal();
                    this.getProject();
                })
                .catch((error) => {
                    this.$swal(
                        'Error',
                        error.response?.data?.message || error.message,
                        'error'
                    );
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        getRandomColor() {
            const colors = [
                'primary',
                'success',
                'warning',
                'danger',
                'info',
                'secondary',
            ];
            const randomIndex = Math.floor(Math.random() * colors.length);
            return colors[randomIndex];
        },
        openDetailModal(item) {
            this.selectedProject = item;
            this.showDetailModal = true;
            this.fetchCoachingDetail(item.coaching_id || item.id);
        },

        async fetchCoachingDetail(id) {
            if (!id) return;

            this.isLoadingDetail = true;
            try {
                const response = await this.$store.dispatch('myIdp/getCoachingDetail', id);
                // Update selectedProject with detailed data
                if (response.data) {
                    this.selectedProject = {
                        ...this.selectedProject,
                        ...response.data,
                        // Map fields for compatibility
                        coaching_id: response.data.id,
                        coaching_title: response.data.title,
                        thumbnail: response.data.cover_image,
                    };
                }
            } catch (error) {
                console.error('Error fetching coaching detail:', error);
                this.$swal('Error', 'Detail coaching belum berhasil dimuat', 'error');
            } finally {
                this.isLoadingDetail = false;
            }
        },

        closeDetailModal() {
            this.selectedProject = null;
            this.showDetailModal = false;
            this.isLoadingDetail = false; // Reset loading state
        },

        handleEdit(project) {
            this.editData = project;
            this.isEditModal = true;
            this.closeDetailModal();
        },

        handleUpdate(formData) {
            if (this.isSaving) return;

            const { title, nik, methodology, competency, category, cover, id } = formData;

            // Debug validation
            console.log('handleUpdate received formData:', formData);
            console.log('handleUpdate validation:', {
                category: category,
                title: title,
                nik: nik,
                methodology: methodology,
                competency: competency,
                competencyType: typeof competency,
                competencyIsArray: Array.isArray(competency),
                competencyLength: Array.isArray(competency) ? competency.length : 'not array',
                id: id,
                cover: cover,
                existingCover: this.editData?.cover_image || this.editData?.thumbnail
            });

            // Improved validation - check if competency is array and has length, or is a non-empty string
            const isCompetencyValid = Array.isArray(competency) ? competency.length > 0 : competency && competency.trim().length > 0;

            // Check if cover is required - mandatory if no existing cover
            const hasExistingCover = this.editData?.cover_image || this.editData?.thumbnail;
            const isCoverValid = cover || hasExistingCover;

            if (!category || !title || !nik || !methodology || !isCompetencyValid || !isCoverValid) {
                this.$swal('Error', 'Lengkapi semua kolom wajib, termasuk gambar cover', 'error');
                return;
            }

            this.isSaving = true;

            // Create FormData for file upload
            const updateData = new FormData();
            updateData.append('title', title);
            updateData.append('coach_nik', nik);
            updateData.append('methodology', methodology);
            updateData.append('type', category);

            // Handle competency array - ensure it's array of strings
            console.log('Processing competency for FormData:', competency);
            if (Array.isArray(competency) && competency.length > 0) {
                // Filter out any non-string values and ensure uniqueness
                const competencyIds = competency
                    .map(comp => {
                        if (typeof comp === 'object' && comp !== null) {
                            return comp.competency_id || comp.id || String(comp);
                        }
                        return typeof comp === 'string' ? comp : String(comp);
                    })
                    .filter(id => id && String(id).trim())
                    .filter((id, index, arr) => arr.indexOf(id) === index); // Remove duplicates

                console.log('Processed competency IDs:', competencyIds);

                if (competencyIds.length > 0) {
                    const competencyString = competencyIds.join(',');
                    console.log('Final competency string to append:', competencyString);
                    updateData.append('related_competencies', competencyString);
                }
            } else if (competency && typeof competency === 'string') {
                console.log('Appending competency as string:', competency);
                updateData.append('related_competencies', competency);
            } else {
                console.log('No valid competency data to append');
            }

            // Add cover image only if a new one is selected
            if (cover && cover instanceof File) {
                updateData.append('cover_image', cover);
            }

            this.$store
                .dispatch('myIdp/updateCoaching', { id, data: updateData })
                .then(() => {
                    this.$swal('Success', 'Coaching berhasil diperbarui', 'success');
                    this.isEditModal = false;
                    this.editData = null;
                    this.getProject(); // Refresh the list
                })
                .catch((error) => {
                    this.$swal(
                        'Error',
                        error.response?.data?.message || error.message || 'Coaching belum berhasil diperbarui',
                        'error'
                    );
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        handleDelete(project) {
            if (!project || (!project.coaching_id && !project.id)) {
                this.$swal('Error', 'Data proyek tidak valid', 'error');
                return;
            }

            // Use coaching_id if available, fallback to id
            const projectId = project.coaching_id || project.id;

            this.$store
                .dispatch('myIdp/deleteCoaching', projectId)
                .then(() => {
                    this.$swal('Success', 'Coaching berhasil dihapus', 'success');
                    this.closeDetailModal();
                    this.getProject(); // Refresh the list
                })
                .catch((error) => {
                    this.$swal(
                        'Error',
                        error.response?.data?.message || error.message || 'Coaching belum berhasil dihapus',
                        'error'
                    );
                });
        },
    },
};
